<template>
  <i
    class="vs-icon notranslate icon-scale"
    :class="[
      iconPack,
      iconPack !== 'material-icons' ? icon : '',
      iconClass,
      backgroundClass,
      backgroundSizeClass,
      { round },
    ]"
    :style="iconStyle"
  >
    <slot>{{ iconPack === "material-icons" ? icon : "" }}</slot>
  </i>
</template>

<script>
const THEME_COLORS = [
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "dark",
  "light",
];

export default {
  name: "VsIcon",
  props: {
    icon: {
      type: String,
      default: null,
    },
    iconPack: {
      type: String,
      default: "material-icons",
    },
    color: {
      type: String,
      default: null,
    },
    bg: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: null,
    },
    round: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconClass() {
      return {
        [this.size]: Boolean(this.size),
        [`vs-icon-${this.color}`]: THEME_COLORS.includes(this.color),
      };
    },
    iconStyle() {
      const customSize = this.size && /(px|em)/.test(this.size);
      return {
        width: customSize ? this.size : null,
        height: customSize ? this.size : null,
        fontSize: customSize ? this.size : null,
        color: this.color,
        background: this.bg,
      };
    },
    backgroundClass() {
      return {
        [`con-vs-icon-bg-${this.bg}`]: THEME_COLORS.includes(this.bg),
      };
    },
    backgroundSizeClass() {
      const hasSize = ["small", "medium", "large"].includes(this.size);
      return {
        [`bg-${this.size}`]: hasSize,
        "vs-icon-bg": hasSize,
      };
    },
  },
};
</script>
